import { readAttribution, clearAttribution } from './attribution.js'
import { fireEvent } from './events.js'
import { watchFormsForSuccess } from './form-watcher.js'

/**
 * Bootstrap cross-page attribution on a destination page.
 * If a valid attribution token exists, watch all forms on the page and
 * fire popup_converted on the first successful submit, reporting how
 * long ago the original click happened.
 */
export function handleCrossPageAttribution() {
  const attribution = readAttribution()
  if (!attribution) return

  // Reconstruct the original click timestamp so we can compute
  // a fresh attribution_age_ms at the moment of conversion.
  const originalTimestamp = Date.now() - attribution.age_ms

  // If the popup specified a convert-target selector, scope the watcher
  // to that form's `.w-form` wrapper. Falls back to whole-page watch
  // if the selector doesn't match anything (graceful degradation).
  let watchRoot = document.body
  if (attribution.convert_target) {
    const target = document.querySelector(attribution.convert_target)
    if (target) {
      watchRoot = target.closest('.w-form') || target.parentElement || document.body
    }
  }

  watchFormsForSuccess(watchRoot, () => {
    fireEvent('popup_converted', {
      popup_id: attribution.popup_id,
      attribution_age_ms: Date.now() - originalTimestamp
    })
    clearAttribution()
  })
}
